module.exports = __webpack_public_path__ + "static/media/STPL.51fc4cd1.png";